/**
 * Mock data for testing the Claim Portal flow.
 */
import { MARGARITAVILLE_BRANDS } from "./config/margaritavilleAccountCatalog";
import type { StoreValidationResponse, SelfOnboardResponse } from "./types";

function margaritavilleMockStores(): Record<string, StoreValidationResponse> {
  const out: Record<string, StoreValidationResponse> = {};
  for (const brand of MARGARITAVILLE_BRANDS) {
    for (const loc of brand.locations) {
      out[loc.storeId] = {
        valid: true,
        message: `Store found: ${loc.name}`,
        store: {
          store_id: loc.storeId,
          business_name: loc.name,
          address: `Demo address — ${brand.name}`,
          symbol: "MV",
          eircode: null,
          is_active: true
        }
      };
    }
  }
  return out;
}

// Mock stores database
export const mockStores: Record<string, StoreValidationResponse> = {
  "22223001": {
    valid: true,
    message: "Store found: SuperValu Dun Laoghaire",
    store: {
      store_id: "22223001",
      business_name: "SuperValu Dun Laoghaire",
      address: "45 George's Street Upper, Dún Laoghaire, Co. Dublin",
      symbol: "SV",
      eircode: "A96 K2C3",
      is_active: true,
    },
  },
  "22223002": {
    valid: true,
    message: "Store found: Centra Blackrock",
    store: {
      store_id: "22223002",
      business_name: "Centra Blackrock",
      address: "12 Main Street, Blackrock, Co. Dublin",
      symbol: "CN",
      eircode: "A94 T8P2",
      is_active: true,
    },
  },
  "22223003": {
    valid: true,
    message: "Store found: Mace Stillorgan",
    store: {
      store_id: "22223003",
      business_name: "Mace Stillorgan",
      address: "78 Stillorgan Road, Stillorgan, Co. Dublin",
      symbol: "MC",
      eircode: "A94 F2K8",
      is_active: true,
    },
  },
  "22223004": {
    valid: false,
    message: "Store '22223004' is no longer active. Please contact support.",
    store: null,
  },
  ...margaritavilleMockStores()
};

// Default response for unknown store IDs
export const unknownStoreResponse: StoreValidationResponse = {
  valid: false,
  message: "No store found with this ID. Please check the store ID and try again.",
  store: null,
};

// Mock self-onboard response
export const mockSelfOnboardResponse = (storeName: string): SelfOnboardResponse => ({
  success: true,
  message: "Successfully registered! You will receive login instructions via email.",
  store_name: storeName,
  request_id: `req-${Date.now()}`,
});

/**
 * Simulate API delay
 */
export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
